<form class="vl-form" @submit="onSubmit">
    <vl-modal id="invoice-setting-modal" :modLocked="false" mod-small :closable="true">
        <vl-title tag-name="h3">Wijzig facturatiegegevens</vl-title>
        <vl-u-spacer mod-medium/>
        <vl-form-grid mod-stacked>
            <template v-if="showAddressInfo">
                <vl-column width="8">
                    <kl-field-validation-wrapper-yup :field="fields.vatNumber" #default="{hasErrors}">
                        <vl-input-field name="KBO-nummer" mod-disabled id="vatNumber" v-model="vatNumber" :mod-error="hasErrors" mod-block />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <vl-column width="4" />
                <vl-column width="12">
                    <vl-title tag-style="h5">Maatschappelijke zetel</vl-title>
                    <kl-address-form ref="addressForm" v-model="address" :form-path="fields.address.path" />
                    <vl-u-spacer />
                </vl-column>
            </template>
            <vl-column width="12">
                <vl-title tag-name="h5" v-if="showAddressInfo">Extra facturatiegegevens</vl-title>
                <kl-field-validation-wrapper-yup :field="fields.attention" #default="{hasErrors}">
                    <vl-input-field name="Ter attentie van" v-model="attention" :mod-error="hasErrors" mod-block/>
                </kl-field-validation-wrapper-yup>
            </vl-column>

            <vl-column width="12">
                <kl-field-validation-wrapper-yup :field="fields.reference" #default="{hasErrors}"
                                                 annotation="Optioneel veld op uw volgende factuur. Vul bv. een interne bestelbon- of PO-nummer in.">
                    <vl-input-field name="Eigen Referentie" v-model="reference" :mod-error="hasErrors" mod-block/>
                </kl-field-validation-wrapper-yup>
            </vl-column>

            <vl-column width="12">
                <kl-field-validation-wrapper-yup :field="fields.reminderEmail" annotation="Elke 25ste van de maand ontvang je op dit e-mailadres een herinnering om je facturatiegegevens na te kijken. De factuur zelf wordt via Peppol verzonden." #default="{hasErrors}">
                    <vl-input-field name="E-mail" v-model="reminderEmail" :mod-error="hasErrors" mod-block/>
                </kl-field-validation-wrapper-yup>
            </vl-column>
            <template v-if="showContactInfo">
                <vl-column width="12">
                    <vl-title tag-name="h5">Contactpersoon i.v.m. facturatie</vl-title>
                    <kl-field-validation-wrapper-yup :field="fields.invoiceContactName" #default="{hasErrors}">
                        <vl-input-field name="invoice-name" v-model="invoiceContactName" :mod-error="hasErrors" mod-block />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <vl-column width="12">
                    <kl-field-validation-wrapper-yup :field="fields.invoiceContactEmail" #default="{hasErrors}">
                        <vl-input-field name="invoice-email" v-model="invoiceContactEmail" :mod-error="hasErrors" mod-block />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
                <vl-column width="12">
                    <kl-field-validation-wrapper-yup :field="fields.invoiceContactPhoneNumber" #default="{hasErrors}">
                        <vl-input-field name="invoice-phone" placeholder="+32" v-model="invoiceContactPhoneNumber" :mod-error="hasErrors" mod-block />
                    </kl-field-validation-wrapper-yup>
                </vl-column>
            </template>
        </vl-form-grid>

        <template v-slot:modal-footer>
            <vl-action-group>
                <vl-button type="submit" mod-large :mod-disabled="disableSubmit" :mod-loading="isSending">
                    Bewaar facturatiegegevens
                </vl-button>
                <vl-button type="button" mod-link @click="cancel" icon="cross" mod-icon-before>
                    Annuleer
                </vl-button>
            </vl-action-group>
        </template>
    </vl-modal>
</form>
